import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import About from '../views/About.vue'
// import Contact from '../views/Contact.vue'
// import Projects from '../views/Projects.vue'
// import Testimonials from '../views/Testimonials'
// import BecomeAnAgent from '../views/BecomeAnAgent'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about-us',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import('../views/Projects.vue')
  },
  {
    path: '/contact-us',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/testimonials',
    name: 'Testimonials',
    component: () => import('../views/Testimonials.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('../views/Blog.vue')
  },
  {
    path: '/estates',
    name: 'Estates',
    component: () => import('../views/Estates.vue')
  },
  {
    path: '/an-agent',
    name: 'BecomeAnAgent',
    component: () => import('../views/BecomeAnAgent.vue')
  },
  {
    path: '/serviced-plots',
    name: 'ServicedPlots',
    component: () => import('../views/ServicedPlots.vue')
  },
  {
    path: '/our-houses',
    name: 'OurHouses',
    component: () => import('../views/OurHouses.vue')
  },
  {
    path: '/privacy-policy',
    name: 'Privacy',
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/our-houses/:houseSlug',
    name: 'OurHousesDetails',
    component: () => import('../views/OurHousesDetails.vue')
  },
  {
    path: '/executives/:slug',
    name: 'ExecDetails',
    component: () => import('../views/ExecDetails.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
